import { changedOperationCategorySchema } from '@klopotun/contracts';
import { apiRequest } from '../../../../shared/api/index.js';
import type {
  OperationCategoryChange,
  OperationCategoryChanged,
} from '../../model/bank-operation.js';
import type { ChangedOperationCategoryDto } from '../dto/bank-operation.dto.js';
import type { OperationCategoryBodyDto } from '../dto/operation-category-body.dto.js';
import { toOperationCategoryChanged } from '../mappers/changed-operation-category.mapper.js';
import { toOperationCategoryBody } from '../mappers/operation-category-body.mapper.js';

const patchOperationCategory = async (
  operationId: string,
  body: OperationCategoryBodyDto,
): Promise<ChangedOperationCategoryDto> =>
  changedOperationCategorySchema.parse(
    await apiRequest<unknown>(`/bank/transactions/${operationId}`, { method: 'PATCH', body }),
  );

export const changeOperationCategory = async (
  change: OperationCategoryChange,
): Promise<OperationCategoryChanged> =>
  toOperationCategoryChanged(
    await patchOperationCategory(change.operationId, toOperationCategoryBody(change)),
  );
